export const theme = {
  bg: "black",
  grey: "#3A3D40",
  toDoBg: "#1A1C20",
};
